import * as React from 'react'

interface IStarProps {
  width?: number
  height?: number
}

const StarLarge = ({ width = 20, height = 21, ...props }: IStarProps) => (
  <svg width={width} height={height} viewBox="0 0 20 21" fill="none">
    <path
      d="M17.5065 9.14C18.064 9.30799 18.6557 9.43927 19.2648 9.53006C19.4405 9.55625 19.5722 9.70417 19.5781 9.88163C19.5838 10.059 19.4619 10.2152 19.2884 10.2527C17.9168 10.5497 16.6784 11.0418 15.608 11.7155C12.257 13.8266 11.1197 17.2975 10.7555 19.8373C10.7302 20.0137 10.5818 20.1467 10.4035 20.1524C10.4221 20.159 10.0959 20.1677 10.0315 19.8608C9.00645 14.99 5.93666 11.5978 0.936339 10.8354C0.534823 10.7741 0.516677 10.1996 0.913417 10.1131C5.90192 9.02497 8.7015 5.44175 9.42053 0.476641C9.47926 0.071786 10.0605 0.0535647 10.1445 0.453889C11.0302 4.6795 13.42 7.90849 17.5065 9.14Z"
      fill="#FFEC3F"
    />
  </svg>
)

export default StarLarge
